var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineEditComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2,7c0-3.2,2.6-5.8,5.8-5.8s5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8S6.2,10.2,6.2,7z M7.8,7     c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2S14.3,2.8,12,2.8S7.8,4.7,7.8,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,22c0-4.3,4.2-7.8,9.3-7.8     c0.4,0,0.7,0.3,0.7,0.8s-0.3,0.8-0.7,0.8c-4.3,0-7.8,2.8-7.8,6.2c0,0.4-0.3,0.8-0.7,0.8S2.7,22.4,2.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,19.7c-0.4,0-0.8-0.3-0.8-0.8     s0.3-0.8,0.8-0.8h6c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,16.7c-0.4,0-0.8-0.3-0.8-0.8     s0.3-0.8,0.8-0.8h6c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,22.7c-0.4,0-0.8-0.3-0.8-0.8     s0.3-0.8,0.8-0.8h3c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineEditComments);
export default __webpack_public_path__ + "static/media/outline-edit-comments.53dde3cedf77b5b3d1da603129c1d60d.svg";
export { ForwardRef as ReactComponent };